// libraries
import React from 'react'


// ARROWS

export function ArrowRight() {
    return (
        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.800049 5.30005H11.7V5.70005H0.800049V5.30005Z"/><path d="M7.49988 0.717163L12.2827 5.50001L7.49988 10.2828L7.21704 10L11.717 5.50001L7.21704 1.00001L7.49988 0.717163Z"/></svg>
    )
}

export function ArrowLeft() {
    return (
        <svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><path d="M11.4827 4.98279L0.582667 4.98279L0.582667 4.58279L11.4827 4.58279L11.4827 4.98279Z"/><path d="M4.78283 9.56567L-1.1026e-05 4.78283L4.78283 -1.20298e-05L5.06567 0.282831L0.565674 4.78283L5.06567 9.28283L4.78283 9.56567Z"/></svg>
    )
}

export function ArrowUpRight() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.25 18L17.25 6" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M8.25 5.25H18V15" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export function ArrowLineDown() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3V16.5" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M5.25 10.5L12 17.25L18.75 10.5" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
            <path d="M3.75 20.25H20.25" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function ArrowDown() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13 4V3H11V4L11 17.8358L5.95714 12.7929L5.25003 12.0858L3.83582 13.5L4.54292 14.2071L11.2929 20.9571L12 21.6642L12.7071 20.9571L19.4571 14.2071L20.1642 13.5L18.75 12.0858L18.0429 12.7929L13 17.8358L13 4Z" fill="#002855" />
        </svg>

    )
}

export function ArrowUp() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11 20L11 21L13 21L13 20L13 6.16421L18.0429 11.2071L18.75 11.9142L20.1642 10.5L19.4571 9.79289L12.7071 3.04289L12 2.33579L11.2929 3.04289L4.54286 9.79289L3.83576 10.5L5.24997 11.9142L5.95708 11.2071L11 6.16421L11 20Z" fill="#002855" />
        </svg>)
}

export function ArrowOut() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15 3.70001H14.2V5.30001H15H17.5686L13.4343 9.43433L12.8686 10L14 11.1314L14.5657 10.5657L18.7 6.43138V9.00001V9.80001H20.3V9.00001V4.50001V3.70001H19.5H15ZM5.30001 14.2V15V17.5686L9.43433 13.4343L10 12.8686L11.1314 14L10.5657 14.5657L6.43138 18.7H9.00001H9.80001V20.3H9.00001H4.50001H3.70001V19.5V15V14.2H5.30001Z" fill="#002855" />
        </svg>
    )
}

export function ArrowIn() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20.0657 5.06571L20.6314 4.50002L19.5 3.36865L18.9343 3.93434L15.05 7.81865V5.25002V4.45002H13.45V5.25002V9.75002V10.55H14.25H18.75H19.55V8.95002H18.75H16.1814L20.0657 5.06571ZM4.45002 13.45H5.25002H9.75002H10.55V14.25V18.75V19.55H8.95002V18.75V16.1814L5.06571 20.0657L4.50002 20.6314L3.36865 19.5L3.93434 18.9343L7.81865 15.05H5.25002H4.45002V13.45Z" fill="#002855" />
        </svg>
    )
}

// CARETS - CHEVRONS

export function CaretDown() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5 9L12 16.5L4.5 9" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export function CaretUp() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 15L12 7.5L19.5 15" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
        </svg>

    )
}

export function CaretRight() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4.5L16.5 12L9 19.5" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function CaretLeft() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 19.5L7.5 12L15 4.5" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function Plus() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 12H20.25" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M12 3.75V20.25" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function Times() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 5.25L5.25 18.75" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M18.75 18.75L5.25 5.25" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>

    )
}

export function Minus() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 12H20.25" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function Check() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 6.75L9.75 17.25L4.5 12" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export function Atention() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#BD002A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 12.75L12 7.5" stroke="#BD002A" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15Z" fill="#BD002A" />
        </svg>
    )
}

export function NotePencil() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 20H12V16L24 4L28 8L16 20Z" stroke="#335377" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 7L25 11" stroke="#335377" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M27 15V27H5L5 5L17 5" stroke="#335377" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export function Search() {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.28907 16.0156C13.0041 16.0156 16.0156 13.0041 16.0156 9.28907C16.0156 5.57409 13.0041 2.5625 9.28907 2.5625C5.57409 2.5625 2.5625 5.57409 2.5625 9.28907C2.5625 13.0041 5.57409 16.0156 9.28907 16.0156Z" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
            <path d="M14.0449 14.0449L17.9368 17.9368" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
        </svg>
    )
}

export function AccentArrow() {
    return (
        <svg width="61" height="48" viewBox="0 0 61 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.8622 0H40.304L60.5 24.076L40.4314 48H27.9896L44.053 28.8506H0.5V19.3014H44.053L27.8622 0Z" fill="#D42702" />
        </svg>
    )
}

export function LocationPinSelected() {
    return (
        <svg width="59" height="76" viewBox="0 0 59 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M58.5 29.2308C58.5 55.5385 29.5 76 29.5 76C29.5 76 0.5 55.5385 0.5 29.2308C0.5 21.4783 3.55535 14.0433 8.9939 8.56149C14.4325 3.07966 21.8087 0 29.5 0C37.1913 0 44.5675 3.07966 50.0061 8.56149C55.4447 14.0433 58.5 21.4783 58.5 29.2308Z" fill="#D42702" />
            <path d="M16.5463 33.5982C18.4874 36.4951 21.3876 38.6451 24.7629 39.5441C24.7949 39.5515 24.8252 39.5589 24.8572 39.5681C24.939 39.5904 25.0227 39.6089 25.1063 39.6293C25.1935 39.6497 25.2807 39.6701 25.3696 39.6905C25.3856 39.6942 25.3999 39.696 25.4141 39.6997C26.3429 39.8962 27.3055 40 28.2894 40C31.7945 40 35.0115 38.6859 37.5113 36.5081C37.5362 36.4822 37.554 36.4507 37.538 36.4191C37.5291 36.4043 37.5095 36.3913 37.4846 36.395C37.474 36.395 37.4579 36.4025 37.4348 36.4099C36.4616 36.7972 35.2534 36.9993 33.8727 36.9993C32.8265 36.9993 31.6825 36.8844 30.469 36.6508C30.4281 36.6434 30.3854 36.6323 30.3427 36.6249C30.2537 36.61 30.1647 36.5934 30.0758 36.5767C25.9052 35.776 21.5513 33.7224 18.4091 31.0775L16.5463 33.5982ZM16.5 25.0649C19.4536 28.7848 25.5831 32.2785 31.6042 33.437C36.442 34.3674 39.9827 33.5537 41.2264 31.5724C41.8349 30.2768 42.2673 28.8775 42.4968 27.4077C42.5057 27.3317 42.4968 27.3058 42.4594 27.2928C42.4345 27.2835 42.4007 27.302 42.3812 27.3428C42.374 27.3576 42.3669 27.3725 42.358 27.3873C42.3385 27.4262 42.3189 27.4633 42.2993 27.5004C42.2869 27.5226 42.2744 27.5486 42.2584 27.5764C42.2495 27.593 42.237 27.6116 42.2264 27.6301C41.0538 29.5725 37.6288 30.3751 32.9333 29.4724C27.4122 28.4104 21.7986 25.3114 18.8166 21.9271L16.5 25.0668V25.0649ZM22.836 20.7575C25.6614 23.0892 29.7235 25.0575 33.7322 25.8286C39.2176 26.885 42.7726 25.3467 42.4559 22.3422C42.3776 21.8918 42.2797 21.4489 42.1641 21.0133C42.1499 20.9596 42.1356 20.9058 42.1214 20.8576C41.9203 20.1274 41.6659 19.4193 41.3634 18.7391C41.3278 18.665 41.2923 18.589 41.2567 18.5149C41.246 18.4926 41.2371 18.4722 41.2282 18.4518C41.2086 18.4092 41.1641 18.3295 41.1161 18.3499C41.0983 18.3573 41.0752 18.3814 41.0859 18.4296C41.0876 18.437 41.0912 18.4537 41.0965 18.4778C41.7104 21.1245 38.8191 22.5276 34.2232 21.6435C30.9174 21.0077 27.5652 19.3489 25.3109 17.4046L22.8342 20.7575H22.836ZM35.3709 12.0019C35.3513 12.0037 35.3335 12.0111 35.3175 12.0259C35.2606 12.0741 35.2783 12.1557 35.3264 12.228C35.4403 12.4022 36.2996 13.4253 36.0078 14.1667C35.9829 14.2334 35.9491 14.2946 35.9064 14.3502C35.9046 14.3539 35.9029 14.3576 35.8993 14.3594C35.8993 14.3594 35.8975 14.3594 35.8958 14.3613C35.5897 14.7431 34.846 14.8914 33.8514 14.7005C33.266 14.5874 32.6771 14.3724 32.1468 14.0981C32.1202 14.0851 32.0988 14.074 32.0988 14.074C31.9565 13.9962 31.5597 13.7645 31.4084 13.7645C31.2056 13.7645 30.9974 14.0165 30.8604 14.2056C30.8551 14.213 30.848 14.2204 30.8409 14.2297C30.7964 14.289 30.7519 14.3502 30.7092 14.4113C30.364 14.8858 29.8356 15.6012 29.3836 16.2129C30.816 17.1137 32.5472 17.8328 34.2624 18.1609C37.7871 18.8392 39.9027 17.6234 38.9863 15.4418C38.7337 14.8395 38.2746 14.2278 37.6697 13.6422C37.0202 13.0583 36.3192 12.5356 35.5773 12.0797C35.5132 12.0408 35.442 12 35.3833 12C35.378 12 35.3744 12 35.3691 12" fill="white" />
        </svg>

    )
}

export function LocationPin() {
    return (
        <svg width="59" height="76" viewBox="0 0 59 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M58.5 29.2308C58.5 55.5385 29.5 76 29.5 76C29.5 76 0.5 55.5385 0.5 29.2308C0.5 21.4783 3.55535 14.0433 8.9939 8.56149C14.4325 3.07966 21.8087 0 29.5 0C37.1913 0 44.5675 3.07966 50.0061 8.56149C55.4447 14.0433 58.5 21.4783 58.5 29.2308Z" fill="white" />
            <path d="M16.5463 33.5982C18.4874 36.4951 21.3876 38.6451 24.7629 39.5441C24.7949 39.5515 24.8252 39.5589 24.8572 39.5681C24.939 39.5904 25.0227 39.6089 25.1063 39.6293C25.1935 39.6497 25.2807 39.6701 25.3696 39.6905C25.3856 39.6942 25.3999 39.696 25.4141 39.6997C26.3429 39.8962 27.3055 40 28.2894 40C31.7945 40 35.0115 38.6859 37.5113 36.5081C37.5362 36.4822 37.554 36.4507 37.538 36.4191C37.5291 36.4043 37.5095 36.3913 37.4846 36.395C37.474 36.395 37.4579 36.4025 37.4348 36.4099C36.4616 36.7972 35.2534 36.9993 33.8727 36.9993C32.8265 36.9993 31.6825 36.8844 30.469 36.6508C30.4281 36.6434 30.3854 36.6323 30.3427 36.6249C30.2537 36.61 30.1647 36.5934 30.0758 36.5767C25.9052 35.776 21.5513 33.7224 18.4091 31.0775L16.5463 33.5982ZM16.5 25.0649C19.4536 28.7848 25.5831 32.2785 31.6042 33.437C36.442 34.3674 39.9827 33.5537 41.2264 31.5724C41.8349 30.2768 42.2673 28.8775 42.4968 27.4077C42.5057 27.3317 42.4968 27.3058 42.4594 27.2928C42.4345 27.2835 42.4007 27.302 42.3812 27.3428C42.374 27.3576 42.3669 27.3725 42.358 27.3873C42.3385 27.4262 42.3189 27.4633 42.2993 27.5004C42.2869 27.5226 42.2744 27.5486 42.2584 27.5764C42.2495 27.593 42.237 27.6116 42.2264 27.6301C41.0538 29.5725 37.6288 30.3751 32.9333 29.4724C27.4122 28.4104 21.7986 25.3114 18.8166 21.9271L16.5 25.0668V25.0649ZM22.836 20.7575C25.6614 23.0892 29.7235 25.0575 33.7322 25.8286C39.2176 26.885 42.7726 25.3467 42.4559 22.3422C42.3776 21.8918 42.2797 21.4489 42.1641 21.0133C42.1499 20.9596 42.1356 20.9058 42.1214 20.8576C41.9203 20.1274 41.6659 19.4193 41.3634 18.7391C41.3278 18.665 41.2923 18.589 41.2567 18.5149C41.246 18.4926 41.2371 18.4722 41.2282 18.4518C41.2086 18.4092 41.1641 18.3295 41.1161 18.3499C41.0983 18.3573 41.0752 18.3814 41.0859 18.4296C41.0876 18.437 41.0912 18.4537 41.0965 18.4778C41.7104 21.1245 38.8191 22.5276 34.2232 21.6435C30.9174 21.0077 27.5652 19.3489 25.3109 17.4046L22.8342 20.7575H22.836ZM35.3709 12.0019C35.3513 12.0037 35.3335 12.0111 35.3175 12.0259C35.2606 12.0741 35.2783 12.1557 35.3264 12.228C35.4403 12.4022 36.2996 13.4253 36.0078 14.1667C35.9829 14.2334 35.9491 14.2946 35.9064 14.3502C35.9046 14.3539 35.9029 14.3576 35.8993 14.3594C35.8993 14.3594 35.8975 14.3594 35.8958 14.3613C35.5897 14.7431 34.846 14.8914 33.8514 14.7005C33.266 14.5874 32.6771 14.3724 32.1468 14.0981C32.1202 14.0851 32.0988 14.074 32.0988 14.074C31.9565 13.9962 31.5597 13.7645 31.4084 13.7645C31.2056 13.7645 30.9974 14.0165 30.8604 14.2056C30.8551 14.213 30.848 14.2204 30.8409 14.2297C30.7964 14.289 30.7519 14.3502 30.7092 14.4113C30.364 14.8858 29.8356 15.6012 29.3836 16.2129C30.816 17.1137 32.5472 17.8328 34.2624 18.1609C37.7871 18.8392 39.9027 17.6234 38.9863 15.4418C38.7337 14.8395 38.2746 14.2278 37.6697 13.6422C37.0202 13.0583 36.3192 12.5356 35.5773 12.0797C35.5132 12.0408 35.442 12 35.3833 12C35.378 12 35.3744 12 35.3691 12" fill="#002855" />
        </svg>
    )
}

export function Download() {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 2.5V13.75" stroke="#002855" strokeWidth="1.8" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M4.875 8.75L10.5 14.375L16.125 8.75" stroke="#002855" strokeWidth="1.8" strokeLinecap="square" />
            <path d="M3.625 16.875H17.375" stroke="#002855" strokeWidth="1.8" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function Info() {
    return (
        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 25C20.1274 25 25.5 19.6274 25.5 13C25.5 6.37258 20.1274 1 13.5 1C6.87258 1 1.5 6.37258 1.5 13C1.5 19.6274 6.87258 25 13.5 25Z" stroke="#002855" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.5 12V19" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z" fill="#002855" />
        </svg>

    )
}


export function Newspaper() {
    return (
        <svg width="36" height="30" viewBox="0 0 36 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.43696 27.2808C4.9564 27.7614 4.30462 28.0314 3.625 28.0314H31.8125C32.4921 28.0314 33.1439 27.7614 33.6245 27.2808C34.105 26.8003 34.375 26.1485 34.375 25.4689V1.96875H6.1875V25.4689C6.1875 26.1485 5.91752 26.8003 5.43696 27.2808Z" stroke="#002855" strokeWidth="2" strokeLinecap="round" />
            <path d="M3.625 28.0312C2.94538 28.0312 2.2936 27.7613 1.81304 27.2807C1.33248 26.8001 1.0625 26.1484 1.0625 25.4688V10.0938" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M20 14V21" stroke="#002855" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M20 11C20.8284 11 21.5 10.3284 21.5 9.5C21.5 8.67157 20.8284 8 20 8C19.1716 8 18.5 8.67157 18.5 9.5C18.5 10.3284 19.1716 11 20 11Z" fill="#002855" />
        </svg>
    )
}

export function Hamburguer() {
    return (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="18" height="2" fill="#002855" />
            <rect x="0.5" y="12" width="18" height="2" fill="#002855" />
            <rect x="0.5" y="6" width="18" height="2" fill="#002855" />
        </svg>
    )
}

export function ReziseTextArea() {
    return (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="18" height="2" fill="#002855" />
            <rect x="0.5" y="12" width="18" height="2" fill="#002855" />
            <rect x="0.5" y="6" width="18" height="2" fill="#002855" />
        </svg>
    )
}

export function Zoom() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 25C20.299 25 25 20.299 25 14.5C25 8.70101 20.299 4 14.5 4C8.70101 4 4 8.70101 4 14.5C4 20.299 8.70101 25 14.5 25Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.9258 21.9248L28.0008 27.9998" stroke="black" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>

    )
}

export function ZoomLight() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="8" stroke="#2B3F6C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.5 16.9579L21.5 21.958" stroke="#2B3F6C" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function List() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 16H27" stroke="black" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M5 8H27" stroke="black" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M5 24H27" stroke="black" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    )
}

export function ListLight() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L4 6" stroke="#2B3F6C" strokeWidth="1.5" strokeLinecap="square" />
            <path d="M20 12L4 12" stroke="#2B3F6C" strokeWidth="1.5" strokeLinecap="square" />
            <path d="M20 18H4" stroke="#2B3F6C" strokeWidth="1.5" strokeLinecap="square" />
        </svg>
    )
}

export function Facebook() {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.2396 10.3333C20.2396 4.83331 15.7219 0.333313 10.2003 0.333313C4.67878 0.333313 0.161133 4.83331 0.161133 10.3333C0.161133 15.3333 3.80035 19.4583 8.56898 20.2083V13.2083H6.05917V10.3333H8.56898V8.08331C8.56898 5.58331 10.0749 4.20831 12.3337 4.20831C13.4631 4.20831 14.5925 4.45831 14.5925 4.45831V6.95831H13.3376C12.0827 6.95831 11.7062 7.70831 11.7062 8.45831V10.3333H14.467L13.9651 13.2083H11.5807V20.3333C16.6003 19.5833 20.2396 15.3333 20.2396 10.3333Z" fill="#C0DDFF" />
        </svg>

    )
}

export function Youtube() {
    return (
        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.6897 2.44888C22.4299 1.48497 21.6645 0.725826 20.6926 0.468199C18.9309 6.10352e-05 11.867 6.10352e-05 11.867 6.10352e-05C11.867 6.10352e-05 4.80311 6.10352e-05 3.04144 0.468199C2.06955 0.725867 1.30409 1.48497 1.04429 2.44888C0.572266 4.19602 0.572266 7.84127 0.572266 7.84127C0.572266 7.84127 0.572266 11.4865 1.04429 13.2337C1.30409 14.1976 2.06955 14.9251 3.04144 15.1827C4.80311 15.6509 11.867 15.6509 11.867 15.6509C11.867 15.6509 18.9309 15.6509 20.6926 15.1827C21.6645 14.9251 22.4299 14.1976 22.6897 13.2337C23.1618 11.4865 23.1617 7.84127 23.1617 7.84127C23.1617 7.84127 23.1618 4.19602 22.6897 2.44888ZM9.5567 11.1509V4.53166L15.4607 7.84135L9.5567 11.1509Z" fill="#C0DDFF" />
        </svg>
    )
}

export function LinkedIn() {
    return (
        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.65019 19H0.683529V6.51665H4.65019V19ZM2.66686 4.76665C1.38353 4.76665 0.450195 3.83331 0.450195 2.54998C0.450195 1.26665 1.5002 0.333313 2.66686 0.333313C3.9502 0.333313 4.88353 1.26665 4.88353 2.54998C4.88353 3.83331 3.9502 4.76665 2.66686 4.76665ZM19.1169 19H15.1502V12.2333C15.1502 10.25 14.3335 9.66665 13.1669 9.66665C12.0002 9.66665 10.8335 10.6 10.8335 12.35V19H6.86686V6.51665H10.6002V8.26665C10.9502 7.44998 12.3502 6.16665 14.3335 6.16665C16.5502 6.16665 18.8835 7.44998 18.8835 11.3V19H19.1169Z" fill="#C0DDFF" />
        </svg>

    )
}

export function Instagram() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_927_36374)">
                <g clip-path="url(#clip1_927_36374)">
                    <path d="M9.64581 2.44444H13.4236C14.3125 2.44444 14.7569 2.66666 15.0903 2.77777C15.5347 2.99999 15.868 3.1111 16.2014 3.44444C16.5347 3.77777 16.7569 4.1111 16.868 4.55555C16.9791 4.88888 17.0902 5.33333 17.2014 6.22222V13.7778C17.2014 14.6667 16.9791 15.1111 16.868 15.4444C16.6458 15.8889 16.5347 16.2222 16.2014 16.5555C15.868 16.8889 15.5347 17.1111 15.0903 17.2222C14.7569 17.3333 14.3125 17.4444 13.4236 17.5555H5.86803C4.97914 17.5555 4.5347 17.3333 4.20136 17.2222C3.75692 17 3.42358 16.8889 3.09025 16.5555C2.75692 16.2222 2.53469 15.8889 2.42358 15.4444C2.31247 15.1111 2.20136 14.6667 2.09025 13.7778V6.22222C2.09025 5.33333 2.31247 4.88888 2.42358 4.55555C2.64581 4.1111 2.75692 3.77777 3.09025 3.44444C3.42358 3.1111 3.75692 2.88888 4.20136 2.77777C4.5347 2.66666 4.97914 2.55555 5.86803 2.44444H9.64581ZM9.64581 0.777771H5.86803C4.86803 0.777771 4.20136 0.999993 3.64581 1.22222C3.09025 1.44444 2.53469 1.77777 1.97914 2.33333C1.42358 2.88888 1.20136 3.33333 0.868028 3.99999C0.645806 4.55555 0.534695 5.22222 0.423584 6.22222V13.7778C0.423584 14.7778 0.645806 15.4444 0.868028 16C1.09025 16.5555 1.42358 17.1111 1.97914 17.6667C2.53469 18.2222 2.97914 18.4444 3.64581 18.7778C4.20136 19 4.86803 19.1111 5.86803 19.2222H13.4236C14.4236 19.2222 15.0903 19 15.6458 18.7778C16.2014 18.5555 16.7569 18.2222 17.3125 17.6667C17.868 17.1111 18.0902 16.6667 18.4236 16C18.6458 15.4444 18.7569 14.7778 18.868 13.7778V6.22222C18.868 5.22222 18.6458 4.55555 18.4236 3.99999C18.2014 3.44444 17.868 2.88888 17.3125 2.33333C16.7569 1.77777 16.3125 1.55555 15.6458 1.22222C15.0903 0.999993 14.4236 0.888882 13.4236 0.777771H9.64581Z" fill="#C0DDFF" />
                    <path d="M9.6457 5.22222C6.97903 5.22222 4.86792 7.33333 4.86792 10C4.86792 12.6667 6.97903 14.7778 9.6457 14.7778C12.3124 14.7778 14.4235 12.6667 14.4235 10C14.4235 7.33333 12.3124 5.22222 9.6457 5.22222ZM9.6457 13.1111C7.97903 13.1111 6.53459 11.7778 6.53459 10C6.53459 8.33333 7.86792 6.88889 9.6457 6.88889C11.3124 6.88889 12.7568 8.22222 12.7568 10C12.7568 11.6667 11.3124 13.1111 9.6457 13.1111ZM14.5346 6.22222C14.8293 6.22222 15.1119 6.10516 15.3203 5.89679C15.5286 5.68841 15.6457 5.4058 15.6457 5.11111C15.6457 4.81643 15.5286 4.53381 15.3203 4.32544C15.1119 4.11706 14.8293 4 14.5346 4C14.2399 4 13.9573 4.11706 13.7489 4.32544C13.5405 4.53381 13.4235 4.81643 13.4235 5.11111C13.4235 5.4058 13.5405 5.68841 13.7489 5.89679C13.9573 6.10516 14.2399 6.22222 14.5346 6.22222Z" fill="#C0DDFF" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_927_36374">
                    <rect width="18.8889" height="20" fill="white" transform="translate(0.200195)" />
                </clipPath>
                <clipPath id="clip1_927_36374">
                    <rect width="18.8889" height="20" fill="white" transform="translate(0.200195)" />
                </clipPath>
            </defs>
        </svg>
    )
}   

export function PadLock() {
    return (
        <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg"><path d="M7 12.5C7.86294 12.5 8.5625 11.8004 8.5625 10.9375C8.5625 10.0746 7.86294 9.375 7 9.375C6.13706 9.375 5.4375 10.0746 5.4375 10.9375C5.4375 11.8004 6.13706 12.5 7 12.5Z M7.9001 12.1L7.9001 14.9H6.1001V12.1H7.9001Z M1.9001 7.89998V16.1H12.1001V7.89998H1.9001ZM0.100098 7.62498C0.100098 6.90172 0.636087 6.09998 1.54555 6.09998H12.4546C13.3641 6.09998 13.9001 6.90172 13.9001 7.62498V16.375C13.9001 17.0982 13.3641 17.9 12.4546 17.9H1.54555C0.636087 17.9 0.100098 17.0982 0.100098 16.375V7.62498Z M7.0001 1.89998C6.142 1.89998 5.33929 2.19932 4.76433 2.70242C4.19319 3.20216 3.9001 3.85214 3.9001 4.49998V6.99998C3.9001 7.49703 3.49715 7.89998 3.0001 7.89998C2.50304 7.89998 2.1001 7.49703 2.1001 6.99998V4.49998C2.1001 3.29129 2.64986 2.1608 3.57902 1.34778C4.50434 0.538125 5.73647 0.0999756 7.0001 0.0999756C8.26373 0.0999756 9.49586 0.538125 10.4212 1.34778C11.3503 2.1608 11.9001 3.29129 11.9001 4.49998V6.99998C11.9001 7.49703 11.4972 7.89998 11.0001 7.89998C10.503 7.89998 10.1001 7.49703 10.1001 6.99998V4.49998C10.1001 3.85214 9.807 3.20216 9.23587 2.70242C8.6609 2.19932 7.8582 1.89998 7.0001 1.89998Z" fill="currentColor"/></svg>
    )
}